import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Home.module.css';
import { MonitorSmartphone, ArrowLeft, ArrowRight, Clapperboard, LifeBuoy } from 'lucide-react';

const services = [
    {
        num: '01',
        title: 'DESIGN & DEVELOPMENT',
        icon: MonitorSmartphone,
        desc: 'We design and build the full visual and digital foundation of your brand, from the identity people recognize to the website they interact with.',
        serviceItems: [
            'Brand identity',
            'Web Design',
            'Social Media Design',
            'Landing pages',
            'Custom web/app builds',
            'UX/UI design',
            'SEO foundations',
        ],
        href: '/services/design-development',
    },
    {
        num: '02',
        title: 'CONTENT CREATION',
        icon: Clapperboard,
        desc: 'We produce documentary shorts and features, branded video, and podcasts that build momentum.',
        serviceItems: [
            'Creative Direction',
            'Video Production',
            'Video Post-Production',
            'Podcast Production',
            'Podcast Post-Production',
            'Branded & Impact Video',
            'Documentary Short',
            'Documentary Feature',
        ],
        href: '/services/content-creation',
    },
    {
        num: '03',
        title: 'IT SUPPORT',
        icon: LifeBuoy,
        desc: 'We provide the strategy and technical support that keep your digital platform running and improving long after launch. ',
        serviceItems: [
            'Platform strategy',
            'Customer success optimization',
            'Website Maintenance',
            'Technical Support',
        ],
        href: '/services/it-support',
    },
];

const selectedProjects = [
    {
        num: '01',
        title: 'Assigned Sex: Unarchived',
        category: 'Content Creation',
        services: 'Podcast Production \n Podcast Post-Production',
        year: '2026',
        desc: 'A narrative podcast built to center Black trans and genderqueer voices in conversations about identity, faith, and embodiment, paired with a Black History segment that grounds each episode in historical context. Meshae Studios handled full production and post-production, from interview recording to final mix.',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Production%20Portfolio/Assigned%20Sex%20-%20Black%20Transgender%20Podcast%20-%20Meshae%20Studios.png',
        links: [
            { label: 'Spotify', url: 'https://open.spotify.com/show/0L3Tc7mI8bxns5h5Q27rFG ' },
            { label: 'Apple Podcasts', url: 'https://podcasts.apple.com/us/podcast/assigned-sex/id1876509048' },
        ],
    },
    {
        num: '02',
        title: 'Nandi Kayyy',
        category: 'Design & Development',
        services: 'Web Design \n Web Development',
        year: '2026',
        desc: 'A personal brand site built for a voice performer and stylist with 25 years of experience across film, music, and stage. Meshae Studios designed and developed a site that translates that range into a clear online presence, giving visitors an immediate sense of who Nandi is and how to work with them.',
        image: 'https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Design%20Portfolio/design%20projects/nandikayyy.com.png',
        links: [
            { label: 'nandikayyy.com', url: 'https://www.nandikayyy.com' },
        ],

    }
];
export default function Home() {

    const [activeProjectIndex, setActiveProjectIndex] = useState(0);

    const activeProject = selectedProjects[activeProjectIndex];

    const showPreviousProject = () => {
        setActiveProjectIndex((currentIndex) =>
            currentIndex === 0
                ? selectedProjects.length - 1
                : currentIndex - 1
        );
    };

    const showNextProject = () => {
        setActiveProjectIndex((currentIndex) =>
            currentIndex === selectedProjects.length - 1
                ? 0
                : currentIndex + 1
        );
    };
    useEffect(() => {
        const elements = document.querySelectorAll('[data-reveal]');
        if (!elements.length) return;

        elements.forEach((element, index) => {
            element.style.animationDelay = `${index * 0.1}s`;
            element.classList.add(styles.revealed);
        });
    }, []);

    return (
        <main className={styles.pageContainer}>
            <div className={styles.videoBand}>
                <div
                    className={styles.ctaImageBg}
                    style={{
                        backgroundImage: `url('https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Home/meshae-studios-creative-studio-jacksonville-florida.jpg')`,
                    }}
                    aria-hidden="true"
                />


                <div className={styles.mainHeroOverlay} aria-hidden="true" />

                <div className={styles.heroContent}>
                    <div className={styles.heroIndex} aria-hidden="true">
                        <span className={styles.heroIndexLabel}>Jacksonville, FL · · EST 2025</span>
                    </div>

                    <div className={styles.heroBody}>
                        <p className={styles.eyebrow} data-reveal>
                            Creative Studio - Jacksonville, FL
                        </p>

                        <h1 className={styles.ctaHeading}>
                            Let's make something
                            <br />
                            together.
                        </h1>
                        <p className={styles.ctaBody}>
                            Whether it's a new site, a rebrand, a technical fix, or a story that needs telling, we'd love to hear what you're building and help bring it to life.
                        </p>

                        <div className={styles.heroCtaGroup} data-reveal>
                            <Link to="/new-client" className={styles.heroBtnPrimary}>
                                Let's Create <span aria-hidden="true">→</span>
                            </Link>

                            <a href="mailto:help@meshaestudios.com" className={styles.heroBtnSecondary}>
                                <svg className={styles.heroBtnIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M3 6.5C3 5.67157 3.67157 5 4.5 5H19.5C20.3284 5 21 5.67157 21 6.5V17.5C21 18.3284 20.3284 19 19.5 19H4.5C3.67157 19 3 18.3284 3 17.5V6.5Z" stroke="currentColor" strokeWidth="1.5" />
                                    <path d="M3.5 6.5L12 13L20.5 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                help@meshaestudios.com
                            </a>
                        </div>
                    </div>

                    <div className={styles.scrollCue} aria-hidden="true" data-reveal>
                        <span className={styles.scrollLine} />
                        <span className={styles.scrollLabel}>scroll</span>
                    </div>
                </div>
            </div>

            <section className={styles.heroStage}>

                <div className={styles.servicesBand} data-reveal>
                    <div className={styles.servicesBandHeader}>
                        <p className={styles.svcSectionEyebrow}>What We Do</p>
                        <h2 className={styles.svcSectionHeading}>
                            From your first idea to ongoing support
                        </h2>
                        <p className={styles.svcSectionText}>
                            Instead of piecing together separate designers, developers, producers, and technical support, you get one studio that can help carry the work from idea to launch.
                        </p>
                        <div className={styles.heroCtaGroup} data-reveal>
                            <Link to="/about" className={styles.heroBtnPrimary}>
                                About Meshae Studios <span aria-hidden="true">→</span>
                            </Link>
                        </div>

                    </div>

                    <div className={styles.servicesBandInner}>
                        <div className={styles.servicesLabel} aria-hidden="true">
                            <span>Services</span>
                        </div>
                        {services.map(({ num, title, desc, serviceItems, icon: Icon, href }) => {
                            return (
                                <div
                                    className={`${styles.serviceCell} ${num === '02' ? styles.serviceCellFeatured : ''
                                        }`}
                                    key={num}
                                >
                                    <span className={styles.svcNum}>{num}</span>

                                    <div>
                                        <div className={styles.svcTitleRow}>
                                            <div className={styles.svcIconBadge}>
                                                <Icon className={styles.svcIcon} strokeWidth={1.5} aria-hidden="true" />
                                            </div>

                                            <div className={styles.svcTitle}>
                                                {title.split('\n').map((line, index) => (
                                                    <React.Fragment key={index}>
                                                        {line}
                                                        {index === 0 && <br />}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>

                                        <p className={styles.svcDesc}>{desc}</p>
                                        <div className={styles.svcDivider} aria-hidden="true" />
                                        <div className={styles.svcServices}>
                                            <strong className={styles.svcListLabel}>
                                                Services Include:
                                            </strong>

                                            <div className={styles.svcPillList}>
                                                {serviceItems.map((service) => (
                                                    <span className={styles.svcPill} key={service}>
                                                        {service}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className={styles.studioBand} data-reveal>
                    <div
                        className={styles.studioImageBg}
                        style={{
                            backgroundImage: `url('https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/gift-habeshaw-euBahHmHrRQ-unsplash.jpg')`,
                        }}
                        aria-hidden="true"
                    />

                    <div className={styles.studioOverlay} aria-hidden="true" />

                    <div className={styles.studioContent}>


                        <div className={styles.studioCopy}>
                            <p className={styles.studioEyebrow}>PRICING & PACKAGES</p>

                            <h2 className={styles.studioHeading}>
                                Get the support your project needs.
                            </h2>d

                            <p className={styles.studioBody}>
                                Whether you need a website, content production, or ongoing technical support, our packages give you a clear scope, a starting investment, and a practical path to launch.

                            </p>
                            <div className={styles.heroCtaGroup} data-reveal>
                                <Link to="/packages" className={styles.heroBtnSecondary}>
                                    View Prices & Packages <span aria-hidden="true">→</span>
                                </Link>

                                {/* <Link to="/about" className={styles.heroBtnPrimary}>
                                    About Us <span aria-hidden="true">→</span>
                                </Link> */}
                            </div>
                        </div>
                    </div>
                </div>



                {/* ── Feature Projects ─*/}
                <div className={styles.selectedWorkSection} data-reveal>
                    <div className={styles.selectedWorkInner}>
                        <div className={styles.selectedWorkLabel} aria-hidden="true">
                            <span>Selected Work</span>
                        </div>

                        <div className={styles.selectedWorkBody}>

                            <div className={styles.swSectionHeader}>
                                <p className={styles.swSectionEyebrow}>Selected Work</p>
                                <h2 className={styles.swSectionHeading}>
                                    Traction and <br></br>Proof
                                </h2>
                                <p className={styles.swSectionText}>
                                    From brand-defining websites to documentary-grade production, here's a look at how we bring strategy and storytelling together for real clients.
                                </p>

                                <div className={styles.swSectionActions}>
                                    <Link to="/designlab" className={styles.portfolioPrimaryBtn}>
                                        Design Portfolio <span aria-hidden="true">→</span>
                                    </Link>
                                    <Link to="/production-portfolio" className={styles.portfolioSecondaryBtn}>
                                        Production Portfolio <span aria-hidden="true">→</span>
                                    </Link>
                                </div>
                            </div>
                            <div className={styles.swGallery}>
                                <div className={styles.swGalleryNav}>
                                    <button
                                        type="button"
                                        className={styles.swGalleryArrow}
                                        onClick={showPreviousProject}
                                        aria-label="View previous project"
                                    >
                                        <ArrowLeft size={18} strokeWidth={1.5} aria-hidden="true" />
                                    </button>

                                    <span className={styles.swGalleryCount} aria-live="polite">
                                        ({String(activeProjectIndex + 1).padStart(2, '0')}/
                                        {String(selectedProjects.length).padStart(2, '0')})
                                    </span>

                                    <button
                                        type="button"
                                        className={styles.swGalleryArrow}
                                        onClick={showNextProject}
                                        aria-label="View next project"
                                    >
                                        <ArrowRight size={18} strokeWidth={1.5} aria-hidden="true" />
                                    </button>
                                </div>

                                <div className={styles.swProjectBlock} key={activeProject.num}>
                                    <div className={styles.swMeta}>
                                        <span className={styles.swMetaNum}>
                                            ({activeProject.num}/
                                            {String(selectedProjects.length).padStart(2, '0')})
                                        </span>
                                    </div>

                                    <div className={styles.swContentGrid}>
                                        <div className={styles.swTitleBlock}>
                                            <h2 className={styles.swTitle}>
                                                {activeProject.title}
                                            </h2>

                                            <div className={styles.swImageWrap}>
                                                <img
                                                    src={activeProject.image}
                                                    alt={activeProject.title}
                                                    className={styles.swImage}
                                                />
                                            </div>
                                        </div>

                                        <div className={styles.swDetailsBlock}>
                                            <p className={styles.swDetailsHeading}>
                                                Project Details
                                            </p>

                                            <div className={styles.swTable}>
                                                <div className={styles.swRow}>
                                                    <span className={styles.swRowLabel}>Category</span>
                                                    <span className={styles.swRowValue}>
                                                        {activeProject.category}
                                                    </span>
                                                </div>

                                                <div className={styles.swRow}>
                                                    <span className={styles.swRowLabel}>Services</span>
                                                    <span
                                                        className={styles.swRowValue}
                                                        style={{ whiteSpace: 'pre-line' }}
                                                    >
                                                        {activeProject.services}
                                                    </span>
                                                </div>

                                                <div className={styles.swRow}>
                                                    <span className={styles.swRowLabel}>Year</span>
                                                    <span className={styles.swRowValue}>
                                                        {activeProject.year}
                                                    </span>
                                                </div>

                                                <div className={styles.swRow}>
                                                    <span className={styles.swRowLabel}>
                                                        Project URL
                                                    </span>

                                                    <div className={styles.swRowLinks}>
                                                        {activeProject.links.map((link) => (
                                                            <a
                                                                key={link.url}
                                                                href={link.url.trim()}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={styles.swRowLink}
                                                            >
                                                                {link.label}
                                                                <span aria-hidden="true"> →</span>
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            <p className={styles.swSummary}>
                                                {activeProject.desc}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


            </section>
        </main >
    );
}
